<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZFgPY9/image/1.png" alt="This image is the cover for the book Frazzel McDoo"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Frazzel McDoo
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Calibri",sans-serif;'><span style='font-family:"Arial",sans-serif;color:black;background:white;'>This book </span><span style='font-family:"Arial",sans-serif;color:black;background:white;'>is </span><span style='font-family:"Arial",sans-serif;color:black;background:white;'>about a dog who has one shoe and no laces.</span><span style='font-family:"Arial",sans-serif;color:black;background:white;'> </span><span style='font-family:"Arial",sans-serif;color:black;background:white;'>He raids the fridge. He chases the cat. He goes under the child's bed looking for shoes.</span><span style='font-family:"Arial",sans-serif;color:black;background:white;'> </span><span style='font-family:"Arial",sans-serif;color:black;background:white;'>He swims in the fish tank and gets a lace that works for the child</span><span style='font-family:"Arial",sans-serif;color:black;background:white;'>’s</span><span style='font-family:"Arial",sans-serif;color:black;background:white;'> father</span><span style='font-family:"Arial",sans-serif;color:black;background:white;'>’</span><span style='font-family:"Arial",sans-serif;color:black;background:white;'>s shoe. </span><span style='font-family:"Arial",sans-serif;color:black;background:white;'>And then he</span><span style='font-family:"Arial",sans-serif;color:black;background:white;'> leaves. </span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sean Scott Collins
      </h2>
      
      <p class="authorDescription body article"><p>Sean Scott Collins was born and raised in Vermont. After college, Sean joined the army for 8 years. Then he moved to Cincinnati as a Cable TV Tech. He is now semi-retired in Vermont.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6f3f15b1